import { render, staticRenderFns } from "./CareCommunityList.vue?vue&type=template&id=3269bc75&scoped=true&"
import script from "./CareCommunityList.vue?vue&type=script&lang=js&"
export * from "./CareCommunityList.vue?vue&type=script&lang=js&"
import style0 from "./CareCommunityList.vue?vue&type=style&index=0&id=3269bc75&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3269bc75",
  null
  
)

export default component.exports